import React, { Component } from 'react'
import { Link } from 'react-router'
import classes from '../ResultByCompany.scss'

// Helpers
import { get, isEqual } from 'lodash'
import { formatMoney, isNotNumber } from 'helpers/utilities'
import { orderActions } from 'redux/actionCreators'
import { connect } from 'react-redux'

const mapStateToProps = (state, { product }) => {
  return {
    cartProductMap: get(state, 'order.cartProductMap'),
    userClass: get(state, 'user.me.userClass') || 0
  }
}

const mapDispatchToProps = (dispatch) => ({
  openProductModal: (productKey, amount) =>
    dispatch({ type: 'PRODUCT_MODAL_OPEN', productKey, amount }),
  closeProductModal: () =>
    dispatch({ type: 'PRODUCT_MODAL_CLOSE' }),
  onAddToCart: (payload) => {
    return dispatch(orderActions.attemptAddToCart(payload))
  }
})

@connect(mapStateToProps, mapDispatchToProps)
class ResultByCompany extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modalVisible: false,
      currentProduct: null,
      ...props.products.reduce((amountState, { productCode, unitId }) =>
        ({ ...amountState, [`${productCode}-${unitId}`]: get(props, ['cartProductMap', `${productCode}-${unitId}`, 'amount']) || 0 })
      , {})
    }
  }

  componentDidMount () {
    window.objectFitImages()
  }

  componentWillReceiveProps = (nextProps) => {
    if (!isEqual(this.props.cartProductMap, nextProps.cartProductMap) || (!isEqual(this.props.products, nextProps.products))) {
      this.setState({
        ...nextProps.products.reduce((amountState, { productCode, unitId }) => {
          if (get(nextProps, ['cartProductMap', `${productCode}-${unitId}`, 'amount'])) {
            return { ...amountState, [`${productCode}-${unitId}`]: get(nextProps, ['cartProductMap', `${productCode}-${unitId}`, 'amount']) || 0 }
          }
          return amountState
        }, {})
      })
    } else if (this.props.userClass !== nextProps.userClass) {
      this.setState({ userClass: nextProps.userClass })
    }
  }

  _onMouseEnter = (productKey) => { this.setState({ [`${productKey}Hovered`]: true }) }
  _onMouseLeave = (productKey) => { this.setState({ [`${productKey}Hovered`]: false }) }

  _onEnter = (e, product) => {
    if (e.keyCode === 13) this._onAddToCart(product)
  }
  _onAddToCart = (product) => {
    this.props.closeProductModal()
    const amount = parseInt(this.state[`${product.productCode}-${product.unitId}`], 10)
    if (isNotNumber(amount)) return
    this.props.onAddToCart({
      productCode: product.productCode,
      unitId: product.unitId,
      amount: amount,
      price: this._price(product)
    })
  }

  _onAmountChange = (e, productCode) =>
    this.setState({ [productCode]: e.target.value })

  _price = (product) => product[['retail', 'wholesale1', 'wholesale2', 'wholesale3', 'wholesale4'][this.props.userClass]]

  _renderDesktopRows = ({ imagePath, productCode, unitId, productName, unit, amount, outOfStock, packageSize, remark, ...rest }) => {
    const productKey = `${productCode}-${unitId}`
    const regex = unit.match(/\[(.*?)\]/);
    const perUnit = get(regex, 1) ? regex[1] : 1;
    const stockAmount = Math.floor(rest.stockAmount / perUnit);
    return (
      <tr key={productKey} id={productKey}>
        <td className='text-center'>{productCode}</td>
        <td className='text-center'>
          <img className={classes.smallPic} src={imagePath} alt='product-pic'
            onMouseEnter={() => this._onMouseEnter(productKey)}
            onMouseLeave={() => this._onMouseLeave(productKey)} />
          <div className={`${classes.imageBox} ${this.state[`${productCode}Hovered`] && classes.active}`}>
            <img className={classes.thumbnail} src={imagePath} alt='thumbnail' />
          </div>
        </td>
        <td>
          <Link to={`/products/${productCode}?unitId=${unitId}`}>{productName}</Link>
          {packageSize && <div className={classes.indent}>{packageSize}</div>}
          {remark && <div className={`${classes.indent} ${classes.blue}`}>{remark}</div>}
        </td>
        <td className='text-center'>{formatMoney(this._price(rest))}</td>
        <td className='text-center'>{unit}</td>
        <td className='text-center'>
          {outOfStock ? (
            <span className='strike-through'>หมดชั่วคราว</span>
          ) : (
            <span>
              <input
                type='text'
                className={get(this.props, ['cartProductMap', productKey, 'amount']) && classes.active}
                value={this.state[productKey] || 0}
                onChange={(e) => {
                  if (isNotNumber(e.currentTarget.value)) {
                    this.setState({ [productKey]: 0 })
                  } else if (e.currentTarget.value > stockAmount) {
                    this.setState({ [productKey]: stockAmount })
                  } else {
                    this.setState({ [productKey]: parseInt(e.currentTarget.value || 0, 10) })
                  }
                }} onKeyDown={(e) => this._onEnter(e, { productCode, unitId, ...rest })} />
              <span> / {stockAmount}</span>
            </span>
          )}
        </td>
        <td>
          {Boolean(!outOfStock) && <img src='/images/icon-cart-orange.png' role='presentation' onClick={() => this._onAddToCart({ productCode, unitId, ...rest })} />}
        </td>
      </tr>
    )
  }

  _renderMobileRows = ({ imagePath, productCode, unitId, productName, unit, amount, outOfStock, ...rest }) => {
    const productKey = `${productCode}-${unitId}`
    const regex = unit.match(/\[(.*?)\]/);
    const perUnit = get(regex, 1) ? regex[1] : 1;
    const stockAmount = Math.floor(rest.stockAmount / perUnit);
    return (
      <div
        key={productKey}
        className={`${classes.row} ${classes.body}`}
        onClick={() => this.props.openProductModal(productKey, this.state[productKey] || 0)}>
        <Col index={1}>{productCode}</Col>
        <Col index={2}>{productName}</Col>
        <Col index={3}>{formatMoney(this._price(rest))}</Col>
        <Col index={4}>{unit}</Col>
        <Col index={5}>
          {outOfStock ? (
            <span className='strike-through'>หมดชั่วคราว</span>
          ) : (
            <span>
              <span className={`${classes.input} ${get(this.props, ['cartProductMap', productKey, 'amount']) && classes.active}`}>
                {this.state[productKey] || 0}
              </span>
              <span> / {stockAmount}</span>
            </span>
          )}
        </Col>
      </div>
    )
  }

  _onWishlist = (alreadyAdded) => {
    const { productCode } = this.state.currentProduct || {}
    this.setState({
      currentProduct: {
        ...this.state.currentProduct,
        userId: !alreadyAdded
      }
    })
    if (alreadyAdded) {
      this.props.onRemoveFromWishlist(productCode)
    } else {
      this.props.onAddToWishlist(productCode)
    }
  }

  render () {
    const { title, products } = this.props

    return (
      <div className={classes.result}>
        <div className={classes.companyName}>
          <span>ชื่อบริษัท</span>
          <span>:</span>
          <span>{title}</span>
        </div>
        <div className='desktop'>
          <table>
            <thead>
              <tr>
                <td className='text-center'>รหัสสินค้า</td>
                <td />
                <td className='text-center'>ชื่อสินค้า</td>
                <td className='text-center'>ราคา</td>
                <td className='text-center'>หน่วย</td>
                <td className='text-center'>จำนวน/คลัง</td>
                <td className='text-center' />
              </tr>
            </thead>
            <tbody>{products.filter(_product => this._price(_product) > 0).map(this._renderDesktopRows)}</tbody>
          </table>
        </div>
        <div className='mobile'>
          <div className={classes.table}>
            <div className={classes.row}>
              <Col index={1}>รหัสสินค้า</Col>
              <Col index={2}>ชื่อสินค้า</Col>
              <Col index={3}>ราคา</Col>
              <Col index={4}>หน่วย</Col>
              <Col index={5}>จำนวน/คลัง</Col>
            </div>
            {products.filter(_product => this._price(_product) > 0).map(this._renderMobileRows)}
          </div>
        </div>
      </div>
    )
  }
}

const leftMap = [15, 50, 65, 80]
const Col = ({ style, children, index }) =>
  <div className={classes.col} style={style}>
    {children}
    <div style={{ left: `${leftMap[index - 1]}%` }} className={classes.colBorder} />
  </div>

export default ResultByCompany



/** WEBPACK FOOTER **
 ** ./src/components/products/ResultByCompany.js
 **/